export default {
  prevText: 'Forrige',
  nextText: 'NÃ¦ste'
};
